var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Google",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acbaeeaf-8ee2-41df-96ca-ae372c8d3cae",
    "data-name": "Google-Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b46bfc7e-dbe6-41e8-83c1-55f538b27782",
    "data-name": "btn google light normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b83417dd-8891-4476-bbe5-35a937403493",
    "data-name": "logo googleg 48dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a84857e8-31b8-4464-abe7-91a2363aecf9",
    "data-name": "Shape",
    d: "M17.64,9.205a10.276,10.276,0,0,0-.164-1.841H9v3.481h4.844a4.141,4.141,0,0,1-1.8,2.716V15.82h2.908A8.779,8.779,0,0,0,17.64,9.205Z",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "acc8bded-53cb-44d2-bddc-956c9c9dd68d",
    "data-name": "Shape",
    d: "M9,18a8.594,8.594,0,0,0,5.956-2.18l-2.908-2.259A5.43,5.43,0,0,1,3.964,10.71H.957v2.332A9,9,0,0,0,9,18Z",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aac27ea9-aaca-4dd8-aee3-4dad52eb9b3d",
    "data-name": "Shape",
    d: "M3.964,10.71a5.326,5.326,0,0,1,0-3.42V4.958H.957a9.014,9.014,0,0,0,0,8.084L3.964,10.71Z",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e403c8d7-8bfb-477e-b497-a0a5e32995d0",
    "data-name": "Shape",
    d: "M9,3.58a4.863,4.863,0,0,1,3.44,1.345l2.582-2.581A8.652,8.652,0,0,0,9,0,9,9,0,0,0,.957,4.958L3.964,7.29A5.364,5.364,0,0,1,9,3.58Z",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b87027d4-7beb-493b-b803-4741eb3406f1",
    "data-name": "Shape",
    d: "M0,0H18V18H0Z",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.22fe4a122eec9ef91e4182497cad9d22.svg";
export { ForwardRef as ReactComponent };